import React from "react";
import { Label, Table } from "semantic-ui-react";
import { formatDate, getTimePart } from "@common/components/helpers/datetime";
import { HUMAN_DATE_FORMAT } from "@common/constants/datetime";
import AlertModalAction from "@common/redux/actions/AlertModalAction";

const CustomerReviewsTable = ({
  headings,
  records,
  selectedReview,
  onCustomerReviewClick,
}) => {

  const getReviewTypeLabel = (review) => {
    const id = review?.reviewTypeId;
    if(id === 1) return "Basic Review";
    else if(id === 2) return "Escalated Review";
    return "-";
  };

  const checkReviewType = (review) => {
    const reviewTypeId = review?.reviewTypeId;
    if(reviewTypeId === 1) onCustomerReviewClick(review.id)
    else if(reviewTypeId === 2) AlertModalAction.open("Escalated review can be reviewed in CMS Escalated Reviews tab", "Information");
  }

  return (
    <Table sortable>
      <Table.Header>
        <Table.Row>
          {headings.map((x) => (
            <Table.HeaderCell key={x.name}>
              <span>{x.label}</span>
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {records?.data?.map((review, idx) => {
          const fields = [
            { value: review.id },
            { value: formatDate(review.reviewDate, HUMAN_DATE_FORMAT) },
            { value: getTimePart(review.reviewDate, HUMAN_DATE_FORMAT) },
            { value: getReviewTypeLabel(review) },
          ];
          return (
            <Table.Row
              className="clickable"
              key={`${review.id}_${idx}`}
              onClick={() => checkReviewType(review)}
              active={review.id === selectedReview?.record?.id}
            >
              <Table.Cell>
                <Label color={review?.reviewStatus?.colour?.toLowerCase()}>
                  {review?.reviewStatus.name}
                </Label>
              </Table.Cell>
              {fields.map((field) => (
                <Table.Cell>
                  <span className={review.isClosed ? "" : "text-red"}>
                    {field.value}
                  </span>
                </Table.Cell>
              ))}
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default CustomerReviewsTable;
